export const getApiToastMessage = async (response, fallback) => {
  try {
    const data = await response.clone().json();
    const getArrayMessage = (value) => (
      Array.isArray(value)
        ? value
          .map((item) => (
            typeof item === 'string'
              ? item
              : item?.error_description || item?.message || item?.error
          ))
          .filter((item) => typeof item === 'string' && item.trim())
          .join(', ')
        : ''
    );
    const message =
      data?.message ||
      data?.error?.message ||
      (typeof data?.error === 'string' ? data.error : getArrayMessage(data?.error)) ||
      data?.data?.message ||
      (typeof data?.data?.error === 'string' ? data.data.error : getArrayMessage(data?.data?.error)) ||
      getArrayMessage(data?.errors) ||
      getArrayMessage(data?.data?.errors);

    return typeof message === 'string' && message.trim() ? message : fallback;
  } catch (_) {
    return fallback;
  }
};
